import React, { Component } from 'react'
import $ from 'jquery'
import { Route, NavLink, HashRouter, Router } from "react-router-dom";
export default class LegalNotices extends Component {
    render() {
        return (
            <div id="partnerfaq_legalnotices">
                <h1>Legal Notices</h1>
                To see relevant legal notices and guidelines for Nail spa of america, please follow these links:
                <ul>
                    <li>
                        <NavLink to="/faqs/legalnotices/purchasepolicy">
                            <p>Purchase Policy</p>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/faqs/legalnotices/privacypolicy">
                            <p>Privacy Policy</p>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/faqs/legalnotices/useragreement">
                            <p>User Agreement</p>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/faqs/legalnotices/conditions">
                            <p>Terms & Conditions</p>
                        </NavLink></li>
                    <li>
                        <NavLink to="/faqs/legalnotices/bpp-term&condition">
                            <p>Business Partner Program - Terms & Conditions</p>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/faqs/legalnotices/myreward">
                            <p>My Rewards - Terms & Conditions</p>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/faqs/legalnotices/org">
                            <p>Online Review Guidelines</p>
                        </NavLink>
                    </li>
                </ul>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/partnerfaqs/legalNotices/index.js